import update from "immutability-helper";
import { handle } from "redux-pack";
import { SHIP, DELIVER } from "@ROM/DeliveryStatuses/actions";
import { LIST, SET_PAGE, FIND, FIND_DRAFT, CLEAR_DRAFT, UPDATE_POSITION } from "./actions";

const initialState = {
  loading: false,
  draftOrder: null,
  current: {
    order: null,
    included: [],
  },
  all: {
    orders: [],
    orderStatuses: [],
    customers: [],
    relationships: [],
  },
  /* Pagination data returned from an API response */
  pagination: {
    currentPage: 1,
    perPage: null,
    totalPages: null,
    totalRecords: null,
  },
  totalAmountCents: 0,
  nonInvoicedCents: 0,
};

function reducer(state = initialState, action) {
  const { type, payload } = action;
  const { data: json } = payload || {}; // redux-pack puts API response in its own 'data' attribute, renaming to 'json'

  switch (type) {
    case SET_PAGE:
      return update(state, {
        pagination: {
          currentPage: { $set: payload.page },
        },
      });

    case LIST:
      return handle(state, action, {
        start: (prevState) => {
          return update(prevState, {
            all: {
              orders: { $set: [] },
              relationships: { $set: [] },
            },
            loading: { $set: true },
          });
        },

        finish: (prevState) => {
          return update(prevState, {
            loading: { $set: false },
          });
        },

        success: (prevState) => {
          return update(prevState, {
            all: {
              orders: { $set: json.data },
              relationships: { $set: json.included },
            },
            pagination: { $set: json.meta.pagination },
            totalAmountCents: { $set: json.meta.total_amount_cents || 0},
            nonInvoicedCents: { $set: json.meta.non_invoiced_delivery_total_cents || 0 },
          });
        },
      });

    case FIND:
      return handle(state, action, {
        start: (prevState) => {
          return update(prevState, {
            loading: { $set: true },
          });
        },

        finish: (prevState) => {
          return update(prevState, {
            loading: { $set: false },
          });
        },

        success: (prevState) => {
          return update(prevState, {
            current: {
              order: { $set: json.data },
              included: { $set: json.included },
            },
          });
        },
      });

    case FIND_DRAFT:
      return handle(state, action, {
        success: (prevState) => {
          const cartOrder = (json.data || []).find((o) => !o.attributes.isDraft) || null;
          return update(prevState, {
            draftOrder: { $set: cartOrder },
          });
        },
      });

    case CLEAR_DRAFT:
      return update(state, {
        draftOrder: { $set: null },
      });

    case SHIP:
    case DELIVER:
      return handle(state, action, {
        success: (prevState) => {
          const order = json.included.find((inc) => inc.type === "order");
          return update(prevState, {
            current: {
              order: { $set: order },
            },
          });
        },
      });

    case 'orders/REORDER':
      const { sourceIndex, destinationIndex } = payload;
      if (sourceIndex === destinationIndex) return state;
      
      const newOrders = [...state.all.orders];
      const [removed] = newOrders.splice(sourceIndex, 1);
      newOrders.splice(destinationIndex, 0, removed);
      
      return update(state, {
        all: {
          orders: { $set: newOrders }
        }
      });
    
    case UPDATE_POSITION:
      return handle(state, action, {
        start: (prevState) => prevState,
        success: (prevState) => prevState,
        failure: (prevState) => prevState,
      });

    default:
      return state;
  }
}

export default reducer;
